import React from 'react';

const Horse = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1690_72431)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.18631 10.1078C3.73976 10.3342 4.55977 9.8262 5.8161 8.12153C6.29185 8.31962 6.6648 8.75893 6.82737 9.70087C7.13577 11.4945 6.64568 12.6426 5.96432 14.2206C5.83761 14.513 5.71091 14.8028 5.58778 15.0938H15.3049L15.275 15.0669C15.9384 9.77903 11.4522 7.18228 14.7299 8.81418C13.3218 4.97092 8.98141 3.72038 12.0439 4.11926C10.4684 2.49545 8.48175 1.59797 5.65711 2.16529C5.05704 1.17753 3.62142 -0.928717 4.06131 1.59392L3.3417 0.870282L3.30226 3.41583C2.44638 4.1516 1.97899 6.60282 1.31676 8.19699C0.750164 8.83035 0.532609 9.58768 0.713108 10.7655C1.59528 12.047 2.98788 11.729 3.18631 10.1078Z",
      fill: "#B3B3B3"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1690_72431" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "14.6925",
      height: "14.6925",
      fill: "white",
      transform: "translate(0.650002 0.399994)"
    }
  )))
);
Horse.displayName = "Icons.Horse";

export { Horse };
//# sourceMappingURL=Horse.js.map
